// src/api/api.js
import axios from "axios";
import { getAuth } from "firebase/auth";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:5000",
});

// Add interceptor to attach Firebase ID token to all requests
api.interceptors.request.use(
    async (config) => {
        const auth = getAuth();
        const user = auth.currentUser;
        
        if (user) {
            try {
                const token = await user.getIdToken();
                config.headers.Authorization = `Bearer ${token}`;
            } catch (error) {
                console.error("Error getting Firebase ID token:", error);
            }
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;